<template>
	<div :class="tooltipClasses">
		<div :class="['map-tooltip-header', 'map-tooltip-header-' + hoveredFeatureData.service]">
			{{ $t('home-map.tooltip.headers.' + featureType + '.' + hoveredFeatureData.service) }}
		</div>
		<div class="map-tooltip-content">
			<div v-if="hoveredFeatureData.connected_datetime" class="nobr">
				{{ $t('home-map.tooltip.connectedDatetime') }}:
				<DateTimeDisplay :date="hoveredFeatureData.connected_datetime" :format="'YYYY-MM-DD HH:mm:ss'" />
			</div>
			<div class="nobr">
				{{ $t('home-map.tooltip.username') }}:
				{{ hoveredFeatureData.username }}
			</div>
			<div v-if="hoveredFeatureData.name" class="nobr">
				{{ $t('home-map.tooltip.sessionId') }}:
				{{ hoveredFeatureData.name }}
			</div>
			<div v-if="hoveredFeatureData.quality != null" class="nobr">
				{{ $t('home-map.tooltip.quality') }}:
				<GpsFixQualityDisplay :quality="hoveredFeatureData.quality" />
			</div>
			<div v-if="hoveredFeatureData.ip_address" class="nobr">
				{{ $t('home-map.tooltip.ipAddress') }}:
				{{ hoveredFeatureData.ip_address }}
			</div>
			<div v-if="hoveredFeatureData.outgoing_traffic" class="nobr">
				{{ $t('home-map.tooltip.outgoingTraffic') }}:
				{{ hoveredFeatureData.outgoing_traffic }} {{ $t('home-map.tooltip.outgoingTrafficBytes') }}
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { computed } from 'vue';
import type { PropType } from 'vue';
import { useLocaleData } from '@/locales/useLocaleData';

import DateTimeDisplay from '@/components/common/DateTimeDisplay.vue';
import GpsFixQualityDisplay from '@/components/common/GpsFixQualityDisplay.vue';
import type { FeatureType, VRSParticipantRoverFeatureData } from '@/components/map/types/mapFeatureTypes';

type GetterTooltipFeatureData = VRSParticipantRoverFeatureData & {
	connected_datetime?: string;
	ip_address?: string;
	quality?: number;
	outgoing_traffic?: number;
};

export default {
	components: {
		DateTimeDisplay, GpsFixQualityDisplay,
	},
	props: {
		hoveredFeatureData: {
			type: Object as PropType<GetterTooltipFeatureData>,
			required: true,
		},
		featureType: {
			type: String as PropType<FeatureType>,
			required: true,
		},
	},
	setup() {
		const { localeData } = useLocaleData();
		const tooltipClasses = computed(() => [
			'map-tooltip-style',
			'map-tooltip-position-' + localeData.value.direction,
			'no-pointer-events',
		]);
		return {
			tooltipClasses,
		}
	}
};
</script>

<style scoped>
@import '@/assets/map-tooltip.css';
</style>